import DataGrid from 'components/DataGrid';
import { Grid } from '@mui/material';
import { BtnClear, BtnSearch } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { FormProvider } from 'react-hook-form';
import { useFundIncomePlan } from '../hooks/useFundIncomePlan';
import RenderCellPopoverUpdate from '../Ticket/components/RenderCellPopoverUpdate';

 const FundIncomePlanList = () => {

    //#region Hook
    const {
        dataColumn,
        formSearch,
        getTable,
        onDelete,
        dataRow,
        loadingTable,
        handleClearSearch,
        anchorEl,
        setAnchorEl,
        messagePopper,
        isPermission,
    } = useFundIncomePlan()
    // #endregion

    return (
        <Grid container spacing={1} justifyContent={'flex-start'}>
            <Grid item xs={12} >
                <FormProvider {...formSearch}>
                    <Grid container spacing={2} justifyContent={"flex-end"} alignItems={"start"}>
                        <Grid item xs={12} sm={4} md={3}>
                            <DatePickerItem
                                id={`nYear`}
                                name={`nYear`}
                                label={`ประจำปี`}
                                fullWidth
                                disabled={false}
                                IsYearPicker
                                format='YYYY'
                            />
                        </Grid>
                        <Grid item xs={12} md={'auto'}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item>
                                    <BtnClear id={"btn-clear"} IsCircleWithOutText onClick={() => handleClearSearch()} />
                                </Grid>
                                <Grid item>
                                    <BtnSearch id={"btn-search"} IsCircleWithOutText onClick={() => getTable(dataRow)} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item xs={12} >
                <DataGrid
                    columns={dataColumn}
                    isShowCheckBox={isPermission && dataRow.arrRows.length !== 0}
                    rows={dataRow}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isHiddenFooter={dataRow.arrRows.length === 0}
                    onDelete={onDelete}
                    sTableID='fundIncomeplan'
                    isHiddenToolHead
                    onRowSelectable={(p) => p.row.isAllowDelete}
                    />
            </Grid>
            <RenderCellPopoverUpdate
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                MessagePopper={messagePopper}
            />
        </Grid>
    )
}

export default FundIncomePlanList
